//libs
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';

//styles
import { BadgeContainer, ParentContainer, BadgeContent } from './styles';

interface BadgeProps {
  badgeData: Listing.IProductBadge | undefined;
}
const Badge = ({ badgeData }: BadgeProps) => {
  if (isEmpty(badgeData)) return null;
  return (
    <ParentContainer>
      <BadgeContainer borderColor={badgeData?.borderColor} bgColor={badgeData?.bgColor}>
        <BadgeContent data-test="badge-content" color={badgeData?.titleColor}>
          {badgeData?.title}
        </BadgeContent>
      </BadgeContainer>
    </ParentContainer>
  );
};

export default memo(Badge);
